import React from 'react';

export const SvgTask = (props: any) => (
  <svg viewBox="0 0 21 23" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 20C15.7467 20 20 15.7467 20 10.5C20 5.25329 15.7467 1 10.5 1C5.25329 1 1 5.25329 1 10.5V20.6209C1 21.7814 2.44382 22.3155 3.19907 21.4344L5.59598 18.638C7.02754 19.5025 8.70568 20 10.5 20Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 10.5C21 16.299 16.299 21 10.5 21C8.82262 21 7.23509 20.606 5.82696 19.9051L3.95833 22.0852C2.59888 23.6712 0 22.7098 0 20.6209V10.5C0 4.70101 4.70101 0 10.5 0C16.299 0 21 4.70101 21 10.5ZM5.59598 18.638L3.19907 21.4344C2.44382 22.3155 1 21.7814 1 20.6209V10.5C1 5.25329 5.25329 1 10.5 1C15.7467 1 20 5.25329 20 10.5C20 15.7467 15.7467 20 10.5 20C8.70568 20 7.02754 19.5025 5.59598 18.638Z"
      fill="white"
      fillOpacity="0.65"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.6186 7.09759C15.8471 7.32614 15.8471 7.69669 15.6186 7.92524L9.18096 14.3629C8.95241 14.5914 8.58186 14.5914 8.35331 14.3629L5.42712 11.4367C5.19857 11.2081 5.19857 10.8376 5.42712 10.609C5.65567 10.3805 6.02622 10.3805 6.25477 10.609L8.76714 13.1214L14.7909 7.09759C15.0195 6.86904 15.39 6.86904 15.6186 7.09759Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.76846 14.5343C8.76758 14.5343 8.7667 14.5343 8.76581 14.5343C8.61648 14.5339 8.46725 14.4768 8.35331 14.3629L5.42712 11.4367C5.19857 11.2081 5.19857 10.8376 5.42712 10.609C5.65567 10.3805 6.02622 10.3805 6.25477 10.609L8.76714 13.1214L14.7909 7.09759C15.0195 6.86904 15.39 6.86904 15.6186 7.09759C15.8471 7.32614 15.8471 7.69669 15.6186 7.92524L9.18096 14.3629M9.18096 14.3629C9.06703 14.4768 8.9178 14.5339 8.76846 14.5343Z"
      fill="white"
    />
  </svg>
);
